{
  "id": "bayshore-loop",
  "displayName": "Bayshore Loop",
  "parTimeSeconds": 80,
  "medals": {
    "bronze": 60000,
    "silver": 90000,
    "gold": 120000,
    "legend": 150000
  },
  "startDistance": 8,
  "finishFromEnd": 100,
  "surfaces": [
    {
      "fromPoint": 0,
      "surface": "dry"
    }
  ],
  "wallType": "concrete",
  "controlPoints": [
    {
      "x": 0,
      "y": 0,
      "z": 0,
      "width": 18,
      "bank": 0
    },
    {
      "x": 0.0,
      "y": 0,
      "z": 36.0,
      "width": 18,
      "bank": 0
    },
    {
      "x": 0.0,
      "y": 0,
      "z": 72.0,
      "width": 18,
      "bank": 0
    },
    {
      "x": 0.0,
      "y": 0,
      "z": 108.0,
      "width": 18,
      "bank": 0
    },
    {
      "x": 0.0,
      "y": 0,
      "z": 144.0,
      "width": 18,
      "bank": 0
    },
    {
      "x": 0.0,
      "y": 0,
      "z": 180.0,
      "width": 18,
      "bank": 0
    },
    {
      "x": -2.6,
      "y": 0,
      "z": 213.5,
      "width": 16,
      "bank": 0
    },
    {
      "x": -10.2,
      "y": 0,
      "z": 246.2,
      "width": 16,
      "bank": 0
    },
    {
      "x": -22.7,
      "y": 0,
      "z": 277.3,
      "width": 16,
      "bank": 0
    },
    {
      "x": -39.8,
      "y": 0,
      "z": 306.2,
      "width": 16,
      "bank": 0
    },
    {
      "x": -61.1,
      "y": 0,
      "z": 332.1,
      "width": 16,
      "bank": 0
    },
    {
      "x": -86.1,
      "y": 0,
      "z": 354.5,
      "width": 16,
      "bank": 0
    },
    {
      "x": -114.2,
      "y": 0,
      "z": 372.9,
      "width": 16,
      "bank": 0
    },
    {
      "x": -144.8,
      "y": 0,
      "z": 386.7,
      "width": 16,
      "bank": 0
    },
    {
      "x": -182.3,
      "y": 0,
      "z": 400.4,
      "width": 16,
      "bank": 0
    },
    {
      "x": -219.9,
      "y": 0,
      "z": 414.1,
      "width": 16,
      "bank": 0
    },
    {
      "x": -257.5,
      "y": 0,
      "z": 427.8,
      "width": 16,
      "bank": 0
    },
    {
      "x": -288.7,
      "y": 0,
      "z": 442.6,
      "width": 16,
      "bank": 0
    },
    {
      "x": -316.4,
      "y": 0,
      "z": 463.2,
      "width": 16,
      "bank": 0
    },
    {
      "x": -339.7,
      "y": 0,
      "z": 488.6,
      "width": 16,
      "bank": 0
    },
    {
      "x": -357.7,
      "y": 0,
      "z": 518.0,
      "width": 16,
      "bank": 0
    },
    {
      "x": -369.8,
      "y": 0,
      "z": 550.3,
      "width": 16,
      "bank": 0
    },
    {
      "x": -375.5,
      "y": 0,
      "z": 584.4,
      "width": 16,
      "bank": 0
    },
    {
      "x": -374.6,
      "y": 0,
      "z": 618.9,
      "width": 16,
      "bank": 0
    },
    {
      "x": -367.1,
      "y": 0,
      "z": 652.5,
      "width": 16,
      "bank": 0
    },
    {
      "x": -353.4,
      "y": 0,
      "z": 684.2,
      "width": 16,
      "bank": 0
    },
    {
      "x": -333.8,
      "y": 0,
      "z": 712.6,
      "width": 16,
      "bank": 0
    },
    {
      "x": -312.4,
      "y": 0,
      "z": 738.2,
      "width": 16,
      "bank": 0
    },
    {
      "x": -291.0,
      "y": 0,
      "z": 763.7,
      "width": 16,
      "bank": 0
    },
    {
      "x": -269.6,
      "y": 0,
      "z": 789.2,
      "width": 16,
      "bank": 0
    },
    {
      "x": -247.8,
      "y": 0,
      "z": 819.6,
      "width": 16,
      "bank": 0
    },
    {
      "x": -230.7,
      "y": 0,
      "z": 852.8,
      "width": 16,
      "bank": 0
    },
    {
      "x": -218.8,
      "y": 0,
      "z": 888.2,
      "width": 16,
      "bank": 0
    },
    {
      "x": -212.3,
      "y": 0,
      "z": 925.0,
      "width": 16,
      "bank": 0
    },
    {
      "x": -211.4,
      "y": 0,
      "z": 962.4,
      "width": 16,
      "bank": 0
    },
    {
      "x": -216.0,
      "y": 0,
      "z": 999.5,
      "width": 16,
      "bank": 0
    },
    {
      "x": -226.2,
      "y": 0,
      "z": 1035.4,
      "width": 16,
      "bank": 0
    },
    {
      "x": -234.6,
      "y": 0,
      "z": 1070.3,
      "width": 16,
      "bank": 0
    },
    {
      "x": -235.0,
      "y": 0,
      "z": 1106.1,
      "width": 16,
      "bank": 0
    },
    {
      "x": -227.5,
      "y": 0,
      "z": 1141.1,
      "width": 16,
      "bank": 0
    },
    {
      "x": -212.3,
      "y": 0,
      "z": 1173.6,
      "width": 16,
      "bank": 0
    },
    {
      "x": -190.3,
      "y": 0,
      "z": 1201.9,
      "width": 16,
      "bank": 0
    },
    {
      "x": -162.6,
      "y": 0,
      "z": 1224.6,
      "width": 16,
      "bank": 0
    },
    {
      "x": -130.5,
      "y": 0,
      "z": 1240.5,
      "width": 16,
      "bank": 0
    },
    {
      "x": -95.3,
      "y": 0,
      "z": 1253.3,
      "width": 16,
      "bank": 0
    },
    {
      "x": -60.0,
      "y": 0,
      "z": 1266.2,
      "width": 16,
      "bank": 0
    },
    {
      "x": -24.8,
      "y": 0,
      "z": 1279.0,
      "width": 16,
      "bank": 0
    },
    {
      "x": 10.4,
      "y": 0,
      "z": 1291.8,
      "width": 16,
      "bank": 0
    },
    {
      "x": 42.0,
      "y": 0,
      "z": 1306.5,
      "width": 16,
      "bank": 0
    },
    {
      "x": 70.6,
      "y": 0,
      "z": 1326.5,
      "width": 16,
      "bank": 0
    },
    {
      "x": 95.2,
      "y": 0,
      "z": 1351.2,
      "width": 16,
      "bank": 0
    },
    {
      "x": 115.2,
      "y": 0,
      "z": 1379.7,
      "width": 16,
      "bank": 0
    },
    {
      "x": 130.0,
      "y": 0,
      "z": 1411.3,
      "width": 16,
      "bank": 0
    },
    {
      "x": 139.0,
      "y": 0,
      "z": 1445.0,
      "width": 16,
      "bank": 0
    },
    {
      "x": 142.0,
      "y": 0,
      "z": 1479.7,
      "width": 16,
      "bank": 0
    },
    {
      "x": 139.0,
      "y": 0,
      "z": 1514.5,
      "width": 16,
      "bank": 0
    },
    {
      "x": 130.0,
      "y": 0,
      "z": 1548.1,
      "width": 16,
      "bank": 0
    },
    {
      "x": 115.2,
      "y": 0,
      "z": 1579.7,
      "width": 16,
      "bank": 0
    },
    {
      "x": 98.6,
      "y": 0,
      "z": 1608.6,
      "width": 16,
      "bank": 0
    },
    {
      "x": 81.9,
      "y": 0,
      "z": 1637.5,
      "width": 16,
      "bank": 0
    },
    {
      "x": 65.2,
      "y": 0,
      "z": 1666.3,
      "width": 16,
      "bank": 0
    },
    {
      "x": 48.6,
      "y": 0,
      "z": 1695.2,
      "width": 16,
      "bank": 0
    },
    {
      "x": 31.9,
      "y": 0,
      "z": 1724.1,
      "width": 16,
      "bank": 0
    },
    {
      "x": 15.2,
      "y": 0,
      "z": 1752.9,
      "width": 16,
      "bank": 0
    },
    {
      "x": -1.4,
      "y": 0,
      "z": 1781.8,
      "width": 16,
      "bank": 0
    },
    {
      "x": -18.1,
      "y": 0,
      "z": 1810.7,
      "width": 16,
      "bank": 0
    },
    {
      "x": -34.8,
      "y": 0,
      "z": 1839.6,
      "width": 16,
      "bank": 0
    }
  ]
}
